/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Preview_Action_DraftInputs */

const en_us2_search_preview_action_draft = /** @type {(inputs: Search_Preview_Action_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your trainer prepared a new plan. See what changes before you accept it.`)
};

const pt_br2_search_preview_action_draft = /** @type {(inputs: Search_Preview_Action_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O personal preparou um plano novo. Veja o que muda antes de aceitar.`)
};

const es_419_search_preview_action_draft = /** @type {(inputs: Search_Preview_Action_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu entrenador preparó un plan nuevo. Mira qué cambia antes de aceptarlo.`)
};

const pt_pt2_search_preview_action_draft = /** @type {(inputs: Search_Preview_Action_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O treinador preparou um plano novo. Vê o que muda antes de aceitares.`)
};

const fr_fr2_search_preview_action_draft = /** @type {(inputs: Search_Preview_Action_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton coach a préparé un nouveau programme. Regarde ce qui change avant de l'accepter.`)
};

const de_de2_search_preview_action_draft = /** @type {(inputs: Search_Preview_Action_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Coach hat einen neuen Plan vorbereitet. Sieh dir die Änderungen an, bevor du ihn annimmst.`)
};

const it_it2_search_preview_action_draft = /** @type {(inputs: Search_Preview_Action_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo coach ha preparato una nuova scheda. Guarda cosa cambia prima di accettarla.`)
};

/**
* | output |
* | --- |
* | "Your trainer prepared a new plan. See what changes before you accept it." |
*
* @param {Search_Preview_Action_DraftInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_preview_action_draft = /** @type {((inputs?: Search_Preview_Action_DraftInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Preview_Action_DraftInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_preview_action_draft(inputs)
	if (locale === "es-419") return es_419_search_preview_action_draft(inputs)
	if (locale === "pt-PT") return pt_pt2_search_preview_action_draft(inputs)
	if (locale === "fr-FR") return fr_fr2_search_preview_action_draft(inputs)
	if (locale === "de-DE") return de_de2_search_preview_action_draft(inputs)
	if (locale === "it-IT") return it_it2_search_preview_action_draft(inputs)
	return en_us2_search_preview_action_draft(inputs)
});
export { search_preview_action_draft as "search.preview_action_draft" }